import {NgModule} from '@angular/core';
import {PrintComponent} from './print.component';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {MatSelectModule} from '@angular/material/select';

@NgModule({
  declarations: [
    PrintComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatSelectModule
  ],
  exports: [PrintComponent],
  providers: []
})
export class PrintModule {
}
